export const resetPasswordWhenEditDialogBoxIsClosed = (edit, setPassword) => {
  const userIsNotEditing = !edit;
  if (userIsNotEditing) {
    setPassword("");
  }
};
